import { useEffect, useRef } from "react";


interface Props {
    text: string,
    header: string,
    link: string
    addSpace: boolean,
    onVisible: (index: number) => void; // callback func to notify that its visible
    headersList: string[]
}


function ProjectBlurb(props: Props) {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // props.onVisible(props.header); // notify parent (Projects.tsx) that its visible
                    props.onVisible(props.headersList.indexOf(props.header)); // notify parent (Projects.tsx) that its visible
                }
            },
            { threshold: 0.25 } // move when 25% of component visible
        );

        if (ref.current) observer.observe(ref.current);

        // cleanup
        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };

    }, [props.header]); // useEffect calls when header changes



    return <div ref={ref} className="snap-start min-h-full flex flex-col justify-center p-2">
        <a className="w-100 text-2xl w-2/3 text-[#D2A8FF]" href={props.link!} target="_blank">
            {props.header}
        </a>
        <h2 className="w-100 pt-2 max-w-xl pt-2 max-w-xl whitespace-pre-line">
            {props.text}
        </h2>
    </div>


}
export default ProjectBlurb;